import { HOME } from "../constants/testIds";
import ThemeToggle from "../components/ui/ThemeToggle";

// [1] Height 32px, canvas bg, 1px divider bottom border.
// Centered mono uppercase 11px, tracking +4%.
// Right side: TRACK ORDER + INR chip.  Mobile <768px collapses to single line.
export default function TopUtilityBar() {
  return (
    <div
      data-testid={HOME.topUtilityBar}
      className="h-8 bg-[#0A0A0A] border-b border-[#1F1F1F] flex items-center"
    >
      <div className="mx-auto px-6 w-full max-w-[1440px] flex items-center justify-between text-white gap-3">
        <div className="hidden md:flex items-center w-40">
          <ThemeToggle />
        </div>
        <div className="md:hidden flex items-center">
          <ThemeToggle compact />
        </div>
        <div className="flex-1 flex items-center justify-center">
          <span className="font-mono text-[11px] uppercase tracking-[0.04em] hidden md:inline">
            AUTHENTICATED SOURCE · INDIA STOCK · OPERATED BY ONYX ENTERPRISES
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[0.04em] md:hidden">
            AUTHENTICATED SOURCE · INDIA STOCK
          </span>
        </div>
        <div className="hidden md:flex items-center gap-4 w-40 justify-end">
          <a
            data-testid={HOME.trackOrderLink}
            href="/track-order"
            className="font-mono text-[11px] uppercase tracking-[0.04em] text-white hover:text-[#FF9F1C] transition-colors"
          >
            TRACK ORDER
          </a>
          <span
            data-testid={HOME.currencyChip}
            className="font-mono text-[10px] uppercase tracking-[0.04em] text-[#8A8A8A] border border-[#1F1F1F] px-1.5 py-0.5"
          >
            INR ₹
          </span>
        </div>
      </div>
    </div>
  );
}
